import service from '../Common/'
import constants from '../../../settings/shared/constants'


const _service = (options) => {
  options.baseURL = constants.storageApi.base.url
  if (options.hasOwnProperty('headers')) {
    options.headers['api-token'] = getAPIToken()
  } else {
    options.headers = { 'api-token': getAPIToken() }
  }
  return service(options)
}

const _constructHeader = (storageId, rootFolder) => {
  let headerObj = {};
  if (storageId !== null && storageId !== undefined) {
    headerObj = {
      "storage-id": storageId,
      "root-folder": (rootFolder === null || rootFolder === undefined) ? '' : rootFolder
    }
  }
  return headerObj
}

const getAPIToken = () => {
  let currentUser = JSON.parse(localStorage.getItem("UserProfile"))
  return currentUser.apiToken
}


export default Storage = {

  // get buckets
  getBucketsList: (provisionerName, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.getBuckets,
      method: 'POST',
      data: {},
      headers: {
        "provisioner-id": provisionerName
      },
      onError: onErrorCallBack
    })
  },

  // Prefix
  createPrefix: (name, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.prefixs.createPrefix,
      method: 'PUT',
      data: {
        prefix_name: name
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  deletePrefix: (name, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.prefixs.deletePrefix,
      method: 'DELETE',
      data: {
        prefix_name: name
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  // Objects
  listObjects: (prefix, storageId, rootFolder, pageToken, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.listObjects,
      method: 'POST',
      data: {
        prefix: prefix,
        page_token: pageToken
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })

  },

  downloadObjectUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.downloadObject,
      method: 'POST',
      data: {
        object_name: objectName
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  uploadObjectUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.uploadObject,
      method: 'PUT',
      data: {
        object_name: objectName
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  deleteObject: (objectName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.deleteObject,
      method: 'DELETE',
      data: {
        object_name: objectName
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  copyObject: (objectName, newName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.copyObject,
      method: 'PUT',
      data: {
        object_name: objectName,
        new_name: newName
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  trashObject: (objectName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.trashObject,
      method: 'POST',
      data: {
        prefix: objectName,
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  getObjectVersion: (objectName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.getObjectVersions,
      method: 'POST',
      data: {
        prefix: objectName,
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  downloadVersionFilesUrl: (objectName, version, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.downloadVersion,
      method: 'POST',
      data: {
        object_name: objectName,
        version
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },

  listVersionObjects: (prefix, objectName, storageId, rootFolder, pageToken, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.listVersionObjects,
      method: 'POST',
      data: {
        prefix: prefix,
        page_token: pageToken,
        obj_filter: objectName
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })

  },
  ViewVersionObjects: (objectName, storageId, rootFolder, version, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.ViewVersionObjects,
      method: 'POST',
      data: {
        object_name: objectName,
        version: version
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  },
  uploadAnnotationUrl: (objectName, storageId, rootFolder, onErrorCallBack) => {
    return _service({
      url: constants.storageApi.objects.uploadAnnotationObject,
      method: 'PUT',
      data: {
        object_name: objectName
      },
      headers: _constructHeader(storageId, rootFolder),
      onError: onErrorCallBack
    })
  }
}